document.addEventListener("DOMContentLoaded", () => {
  // 针对每个 section 初始化
  document.querySelectorAll('.akc-switch')?.forEach(section => {
    // IntersectionObserver 控制自动轮播
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          let parentEl = entry.target;
          let imageItems = $(parentEl).find('.inner-image-box .image-item');
          let linkBox = $(parentEl).find('.link-box');
          // 初始化 - 将link改为当前默认的颜色变体
          let defaultActiveLink = $(parentEl).find('.color-btn.first-btn').attr('color-link');
          if(defaultActiveLink) {
            linkBox.attr('href', defaultActiveLink);
          }
          // 初始化 - click切换事件
          $(parentEl).off('click', '.color-btn').on('click', '.color-btn', function(e) {
            e.preventDefault();
            e.stopPropagation();
            let colorTarget = $(this).attr('color-target');
            let colorLink = $(this).attr('color-link');
            if(colorTarget) {
              imageItems.removeClass('active');
              $(parentEl).find(`.image-item[color-target="${colorTarget}"]`).addClass('active');
            }
            if(colorLink) {
              linkBox.attr('href', colorLink);
            }
          });
          observer.unobserve(parentEl); // 只执行一次
        }
      });
    }, { threshold: 0.5 });
    observer.observe(section);
  });
});
